function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.39999 8.8999L1.19999 15.1999C0.799988 15.5999 0.799988 16.1999 1.19999 16.5999C1.59999 16.9999 2.19999 16.9999 2.59999 16.5999L9.49999 9.5999C9.89999 9.1999 9.89999 8.5999 9.49999 8.1999L2.59999 1.1999C2.39999 0.999902 2.19999 0.899902 1.89999 0.899902C1.59999 0.899901 1.39999 0.999902 1.19999 1.1999C0.799989 1.5999 0.799989 2.1999 1.19999 2.5999L7.39999 8.8999Z",
  fill: "black"
});

function SvgNextArrow({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxMCAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjM5OTk5IDguODk5OUwxLjE5OTk5IDE1LjE5OTlDMC43OTk5ODggMTUuNTk5OSAwLjc5OTk4OCAxNi4xOTk5IDEuMTk5OTkgMTYuNTk5OUMxLjU5OTk5IDE2Ljk5OTkgMi4xOTk5OSAxNi45OTk5IDIuNTk5OTkgMTYuNTk5OUw5LjQ5OTk5IDkuNTk5OUM5Ljg5OTk5IDkuMTk5OSA5Ljg5OTk5IDguNTk5OSA5LjQ5OTk5IDguMTk5OUwyLjU5OTk5IDEuMTk5OUMyLjM5OTk5IDAuOTk5OTAyIDIuMTk5OTkgMC44OTk5MDIgMS44OTk5OSAwLjg5OTkwMkMxLjU5OTk5IDAuODk5OTAxIDEuMzk5OTkgMC45OTk5MDIgMS4xOTk5OSAxLjE5OTlDMC43OTk5ODkgMS41OTk5IDAuNzk5OTg5IDIuMTk5OSAxLjE5OTk5IDIuNTk5OUw3LjM5OTk5IDguODk5OVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=";
export { SvgNextArrow as ReactComponent };